// extracted by mini-css-extract-plugin
export default {"card-stock-host__skeleton--container":"styles_card-stock-host__skeleton--container__61O8f","card-stock-host__skeleton":"styles_card-stock-host__skeleton__8koE5"};